//#region src/components/_overlay/scrollLock.ts
var locks = 0;
var saved = null;
/**
* Stops the page scrolling behind a modal layer, padding <body> by the scrollbar's width
* so the page doesn't shift. Counted, so nested modals unlock only when the last closes.
* Returns the unlock function; calling it more than once is harmless.
*/
function lockScroll() {
	if (locks++ === 0) {
		const body = document.body;
		const scrollbar = window.innerWidth - document.documentElement.clientWidth;
		saved = {
			overflow: body.style.overflow,
			paddingRight: body.style.paddingRight
		};
		body.style.overflow = "hidden";
		if (scrollbar > 0) {
			const padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
			body.style.paddingRight = `${padding + scrollbar}px`;
		}
	}
	let released = false;
	return () => {
		if (released) return;
		released = true;
		if (--locks === 0 && saved) {
			document.body.style.overflow = saved.overflow;
			document.body.style.paddingRight = saved.paddingRight;
			saved = null;
		}
	};
}
//#endregion
export { lockScroll };

//# sourceMappingURL=scrollLock.js.map